<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button slot="start" color="dark" fill="clear" (click)="close()"><ion-icon
        name="arrow-back"></ion-icon></ion-button>
    <ion-title>User Permissions</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxPadding="medium" *ngIf="organisationUser" sxCol sxGap="10px">
    <div sxPadding="medium" sxRow sxGap="10px" sxBackground="light" sxRadius="small" sxAlign="center"
      sxDistribution="spaceBetween">
      <div sxCenterize="row" sxGap="10px">
        <avatar-round [size]="40" [imageUrl]="organisationUser?.user?.displayPictureUrl"
          [title]="organisationUser?.user?.name"></avatar-round>
        <div sxCol sxGap="5px">
          <h3 sxMargin="0">{{organisationUser?.user?.name}}</h3>
          <p sxTextSize="small" sxColor="two" sxMargin="0">{{organisationUser.organisation?.name}}</p>
        </div>

      </div>

      <super-button-icon [permissionModule]="ApiModules.OrganisationUser" [permissionOperation]="ApiOperations.create"
        *ngIf="!viewOnlyMode" [action]="deleteUser.bind(this,organisationUser._id)"
        [params]="organisationUser?.user?._id" alertTitle="Delete user" color="danger" slot="end"
        subTitle="Are you sure you want to remove this user ?"></super-button-icon>
    </div>

    <ion-list *ngIf="organisationUser">
      <ion-item>
        <ion-select #roleSelect label="Role" [value]="organisationUser.role" interface="action-sheet"
          [disabled]="viewOnlyMode" (ionChange)="roleChanged($event)">
          <ion-select-option minimumRole="0" [value]="'0'">Admin</ion-select-option>
          <ion-select-option minimumRole="1" [value]="'1'">Editor</ion-select-option>
          <ion-select-option minimumRole="2" [value]="'2'">Viewer</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>

    @if (showZohoPaymentAccount) {
    <div class="zoho-card">
      <p class="zoho-card-title">Zoho Payment Account ID</p>

      @if (hasZohoPaymentAccount) {
      <div class="zoho-mapped">
        <div class="zoho-mapped-info">
          <p class="zoho-account-name">{{ zohoAccountLabel }}</p>
          @if (zohoAccount?.accountName) {
          <p class="zoho-account-id mono">{{ organisationUser.zohoPaymentAccountId }}</p>
          }
        </div>
        @if (canEditZohoPaymentAccount) {
        <button type="button" class="zoho-remove" [disabled]="savingZoho" (click)="clearZohoPaymentAccount()">
          Remove
        </button>
        }
      </div>
      } @else if (canEditZohoPaymentAccount) {
      <p class="zoho-hint">Zoho Books → Banking → open account → copy account_id from URL</p>
      <input class="zoho-input" type="text" [(ngModel)]="zohoPaymentAccountId"
        placeholder="e.g. 3872590000000122008" />
      <super-button type="fill" background="dark" color="light" size="small" [action]="saveZohoPaymentAccount">
        Save
      </super-button>
      } @else {
      <p class="zoho-hint">Not configured</p>
      }
    </div>
    }
  </div>




  <div sxPadding="medium" sxCol sxGap="10px" *ngIf="!loading">
    <h2 sxMargin="5px 15px" sxColor="two" sxTextSize="small">Permissions</h2>
    <ion-list *ngFor="let permissionModule of permissionList">
      <ion-list-header sxColor="two">{{permissionModule.module}}</ion-list-header>
      <ion-item *ngFor="let permission of permissionModule.permissions">
        <ion-toggle *ngIf="!viewOnlyMode" [checked]="getIsPermission(permission.permission)"
          (ionChange)="onPermissionToggle($event, permission.permission)">
          {{permission.name}}
        </ion-toggle>
        <ion-label *ngIf="viewOnlyMode">{{permission.name}}</ion-label>
        <ion-icon *ngIf="viewOnlyMode" slot="end" sxTextSize="24px"
          name="{{getIsPermission(permission.permission) ? 'checkmark-circle' : 'close-circle'}}"
          sxColor="{{getIsPermission(permission.permission) ? 'success' : 'danger'}}"></ion-icon>
      </ion-item>
    </ion-list>
  </div>

</ion-content>
